import { LimitType } from '@shared/models';

export const limitTypes: LimitType[] = ['SINGLE', 'DAILY', 'WEEKLY', 'MONTHLY'];

export const limitDisplayNames: Record<LimitType, string> = {
  SINGLE: 'Single',
  DAILY: '1 Day',
  WEEKLY: '7 Days',
  MONTHLY: '30 Days',
};

export enum LimitAccountType {
  FINANCIAL_ACCOUNT = 'FINANCIAL_ACCOUNT',
  BUSINESS_ACCOUNT = 'BUSINESS_ACCOUNT',
}
